"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.modal = void 0;
var react_1 = __importDefault(require("react"));
var ModalAuto_1 = require("./ModalAuto");
var ModalStore_1 = __importDefault(require("./ModalStore"));
var ModalStore_2 = require("./ModalStore");
Object.defineProperty(exports, "ModalStore", { enumerable: true, get: function () { return ModalStore_2.ModalStore; } });
var ModalMountTarget_1 = require("./ModalMountTarget");
Object.defineProperty(exports, "ModalMountTarget", { enumerable: true, get: function () { return ModalMountTarget_1.ModalMountTarget; } });
exports.modal = function (config) {
    return function () {
        var store = config.store || ModalStore_1.default;
        store.append(function (props) { return react_1.default.createElement(ModalAuto_1.ModalAuto, __assign({}, config, { dispose: props.dispose })); });
    };
};
//# sourceMappingURL=index.js.map